define('vspot-angular/services/message-service',[], function () {
    'use strict';

    return ['resources.Message', function (Message) {

        return {
            /*
             *  Send message
             *
             *  @param    postData: { message: 'string', recipients: [ id, id, id, ... ], messagetype: int, selected_activity: int }
             *            messageType: 0 - message, 1 - thank you, 2 - contribute
             *
             *  @returns  Resource object. See /resources.js documentation for details
             *            Expected return data: { status: boolean }
             */
            send: function (postData) {
                return Message.send(postData);
            },
            /*
             *  Send invitations
             *
             *  @param
             */
            sendInvitations: function (postData) {
                return Message.sendInvitations(postData);
            },
            /*
             *  ReSend invitations
             *
             *  @param
             */
            resendInvitations: function (postData) {
                return Message.resendInvitations(postData);
            },
            /*
             *  Send draft invitation and set invitationsSent to 1.
             *
             *  @param  { invitation_message: string, wampum_message: string, selected_activity: int }
             */
            sendDraftInvitation: function (postData) {
                return Message.sendDraftInvitation(postData);
            },
            /*
             *  Sends all invitations that haven't been sent yet
             *  for a given activity.
             *
             *  @param  activityId - int
             */
            sendPendingInvitations: function (activityId) {
                return Message.sendPendingInvitations({ selected_activity: activityId });
            },
            /*
             *  Gets the number of pending assignment invitations.
             *
             *  @param  activityId - int
             */
            numPendingInvitations: function (activityId) {
                return Message.numPendingInvitations({ selected_activity: activityId });
            },
            /*
            *  Get a list of participants across activities.
            *
            *  params:
            *  "activities":     [OPTIONAL]  An array of activity ids
            *  "groups":         [OPTIONAL]  An array of groups ids
            *  "organizations":  [OPTIONAL]  An array of organization ids
            *  "filter":         [REQUIRED]  A string to determine what participant status to filter by, if any. Available values: "signed_up", "not_signed_up", or "all"
            *  "startdate":      [OPTIONAL]  (applies only to signed_up) - participants signed up at or after this date
            *  "enddate":        [OPTIONAL]  (applies only to signed_up) - participants signed up at or before this date
            *  "exclude_list":   [OPTIONAL]  An array of emails to exclude from the resulting list
            *
            * returns:
            *
            *  {
            *    "activity_participant_list":[{"email":"carol@vspot.com","name":"Carol Smith"},{"email":"nicole@vspot.com", "name":"Nicole Jones"}],
            *    "group_participant_list":[{"email":"carol@vspot.com","name":"Carol Smith"},{"email":"nicole@vspot.com", "name":"Nicole Jones"}],
            *    "organization_participant_list":[{"email":"carol@vspot.com","name":"Carol Smith"},{"email":"nicole@vspot.com", "name":"Nicole Jones"}],
            *    "all_list":[{"email":"carol@vspot.com","name":"Carol Smith"},{"email":"nicole@vspot.com", "name":"Nicole Jones"}]
            *  }
            *
            */
            getParticipants: function (data) {
                data.count_only = false;
                data.send = false;
                data.draft = false;
                return Message.customMessageEntry(data);
            },
            /*
             *  Get a count of participants across activities.
             *
             *  params:
             *  "activities":     [OPTIONAL]  An array of activity ids
             *  "groups":         [OPTIONAL]  An array of groups ids
             *  "organizations":  [OPTIONAL]  An array of organization ids
             *  "filter":         [REQUIRED]  A string to determine what participant status to filter by, if any. Available values: "signed_up", "not_signed_up", or "all"
             *  "startdate":      [OPTIONAL]  (applies only to signed_up) - participants signed up at or after this date
             *  "enddate":        [OPTIONAL]  (applies only to signed_up) - participants signed up at or before this date
             *  "exclude_list":   [OPTIONAL]  An array of emails to exclude from the resulting list
             *
             * returns:
             *
             *  {
             *    "organization_counts": [
             * {
             *    "organization_id": 1,
             *    "all_organization_count": 217,
             *    "filtered_organization_count": 81
             * }
             * ],
             *    "group_counts": [
             *    {
             *        "group_id": 14,
             *    "all_group_count": 13,
             *    "filtered_group_count": 6
             * }
             * ],
             *    "activity_counts": [
             *    {
             *        "activity_id": 13,
             *    "all_activity_count": 11,
             *    "filtered_activity_count": 6
             * },
             *    {
             *        "activity_id": 131,
             *    "all_activity_count": 13,
             *    "filtered_activity_count": 6
             * },
             *    {
             *        "activity_id": 100,
             *    "all_activity_count": 20,
             *    "filtered_activity_count": 7
             * }
             * ]
             *  }
             */
            getParticipantCounts: function (data) {
                data.count_only = true;
                data.send = false;
                data.draft = false;
                return Message.customMessageEntry(data);
            },
            /*
             *  Send a draft of the message that will be sent to participants across activities.
             *
             *  params:
             *  "activities":     [OPTIONAL]  An array of activity ids
             *  "groups":         [OPTIONAL]  An array of groups ids
             *  "organizations":  [OPTIONAL]  An array of organization ids
             *  "filter":         [REQUIRED]  A string to determine what participant status to filter by, if any. Available values: "signed_up", "not_signed_up", or "all"
             *  "startdate":      [OPTIONAL]  (applies only to signed_up) - participants signed up at or after this date
             *  "enddate":        [OPTIONAL]  (applies only to signed_up) - participants signed up at or before this date
             *  "exclude_list":   [OPTIONAL]  An array of emails to exclude from the resulting list
             *
             *  "subject":        [REQUIRED]  The subject of the message you wish to send.
             *  "message":        [REQUIRED]  The body of the message you wish to send.
             *  "messagetype":    [REQUIRED]  The type of message being sent. Available values: "group_invitation", "activity_invitation", "message", "thank_you"
             *  "activity_links": [OPTIONAL]  IDs for any activity links you wish to include in the message.
             *  "group_links":    [OPTIONAL]  IDs for any group links you wish to include in the message.
             *
             * returns: ???
             */
            sendSuperDraft: function (data) {
                data.count_only = false;
                data.send = false;
                data.draft = true;
                return Message.customMessageEntry(data);
            },
            /*
             *  Send a message to participants across activities.
             *
             *  params:
             *  "activities":     [OPTIONAL]  An array of activity ids
             *  "groups":         [OPTIONAL]  An array of groups ids
             *  "organizations":  [OPTIONAL]  An array of organization ids
             *  "filter":         [REQUIRED]  A string to determine what participant status to filter by, if any. Available values: "signed_up", "not_signed_up", or "all"
             *  "startdate":      [OPTIONAL]  (applies only to signed_up) - participants signed up at or after this date
             *  "enddate":        [OPTIONAL]  (applies only to signed_up) - participants signed up at or before this date
             *  "exclude_list":   [OPTIONAL]  An array of emails to exclude from the resulting list
             *
             *  "subject":        [REQUIRED]  The subject of the message you wish to send.
             *  "message":        [REQUIRED]  The body of the message you wish to send.
             *  "messagetype":    [REQUIRED]  The type of message being sent. Available values: "group_invitation", "activity_invitation", "message", "thank_you"
             *  "activity_links": [OPTIONAL]  IDs for any activity links you wish to include in the message.
             *  "group_links":    [OPTIONAL]  IDs for any group links you wish to include in the message.
             *
             * returns: ???
             */
            sendSuperMessage: function (data) {
                data.count_only = false;
                data.send = true;
                data.draft = false;
                return Message.customMessageEntry(data);
            }
        };
    }];
});

